import React, {useEffect, useState} from "react";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import MDBox from "../../components/MDBox";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import MDCard from "../../components/MDCard";
import MDButton from "../../components/MDButton";
import DataTable from "../../examples/Tables/DataTable";
import MDInput from "../../components/MDInput";
import {
    mostrarRegistrosStock,
    mostrarRegistrosYonke, mostrarRegistrosImport
} from "./actions/Request";
import Card from "@mui/material/Card";
import MDAvatar from "../../components/MDAvatar";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";


function Registros() {
    function getCurrentDate() {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed, so we add 1
        const day = String(date.getDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }

    const [load, setLoad] = useState(false)
    const [tipoRegistro, setTipoRegistro] = useState('modifStock')
    const [registrosYonke, setRegistrosYonke] = useState(null)
    const [registrosImport, setRegistrosImport] = useState(null)
    const [registrosStock, setRegistrosStock] = useState(null)
    const [registrosYonkeFilt, setRegistrosYonkeFilt] = useState(null)
    const [registrosImportFilt, setRegistrosImportFilt] = useState(null)
    const [registrosStockFilt, setRegistrosStockFilt] = useState(null)
    const [check, setCheck] = useState(false)
    const [checkMan, setCheckMan] = useState(true)
    const [checkAut, setCheckAut] = useState(true)


    const [strtojson, setStrtojson] = useState([])
    const [checkidProducto, setCheckidProducto] = useState(true)
    const [checkProducto, setCheckProducto] = useState(true)
    const [checkiFisAnterior, setCheckiFisAnterior] = useState(true)
    const [checkiFisNuevo, setCheckiFisNuevo] = useState(true)
    const [checkiFullAnterior, setCheckiFullAnterior] = useState(true)
    const [checkiFullNuevo, setCheckiFullNuevo] = useState(true)
    const [checkStockAlAnt, setCheckStockAlAnt] = useState(true)
    const [checkStockAlNue, setCheckStockAlNue] = useState(true)
    const [checkTipoVenta, setCheckTipoVenta] = useState(true)
    const [checkBuenEstado, setCheckBuenEstado] = useState(true)
    const [checkFecha, setCheckFecha] = useState(true)
    const [checkHora, setCheckHora] = useState(true)
    const [checkModifPor, setCheckModifPor] = useState(true)
    const [checkTipoModif, setCheckTipoModif] = useState(true)


    const [formData, setFormData] = useState({
        fechainicio: getCurrentDate(),
        fechafin: getCurrentDate()
    });


    const handleChangeFecha = (e) => {
        const ob = {...formData}
        ob[e.target.id] = e.target.value
        setFormData(ob);
    }


    const handleFiltrarRegistros = () => {
        setLoad(true)

        getData(tipoRegistro)
    }

    const onCheck = (e) => {
        setCheck(e.target.checked)

    }

    const onCheckManuales = (e) => {
        setCheckMan(e.target.checked)

    }

    const onCheckAutomaticas = (e) => {
        setCheckAut(e.target.checked)

    }



    useEffect(() => {
        if(check){
            if(registrosYonke!==null){
                setRegistrosYonke(registrosYonke.filter(item => item.eliminadoPor_id !== parseInt(localStorage.getItem('user_id'))))
            }
            if(registrosImport!==null){
                setRegistrosImport(registrosImport.filter(item => item.eliminadoPor_id !== parseInt(localStorage.getItem('user_id'))))
            }
            if(registrosStock!==null){

                let filtro1= registrosStockFilt.filter(item => item.modificadoPor_id !== parseInt(localStorage.getItem('user_id')))
                let filtro2= filtro1.filter(item => item.modifManual !== (!checkMan?'MANUAL':'N/A'))
                let filtro3= filtro2.filter(item => item.modifManual !== (!checkAut?'AUT':'N/A'))
                setRegistrosStock(filtro3)
            }
        }else{
            setRegistrosYonke(registrosYonkeFilt)
            setRegistrosImport(registrosImportFilt)

            if(registrosStock!==null){

                let filtro2= registrosStockFilt.filter(item => item.modifManual !== (!checkMan?'MANUAL':'N/A'))
                let filtro3= filtro2.filter(item => item.modifManual !== (!checkAut?'AUT':'N/A'))


                setRegistrosStock(filtro3)
            }



        }
        //eslint-disable-next-line
    }, [check,checkMan, checkAut,registrosYonkeFilt,registrosImportFilt,registrosStockFilt]);

    const getData = async (type,reset) => {
        if (type === 'devolucionesYonke') {
            const res = await mostrarRegistrosYonke(reset?{"fechainicio":getCurrentDate(),"fechafin":getCurrentDate()}:formData);
            if (res) {
                setRegistrosYonke(res)
                setRegistrosYonkeFilt(res)
            }
        }
        if (type === 'devolucionesImport') {
            const res = await mostrarRegistrosImport(reset?{"fechainicio":getCurrentDate(),"fechafin":getCurrentDate()}:formData);
            if (res) {
                setRegistrosImport(res);
                setRegistrosImportFilt(res);
            }
        }
        if (type === 'modifStock') {
            const res = await mostrarRegistrosStock(reset?{"fechainicio":getCurrentDate(),"fechafin":getCurrentDate()}:formData);
            if (res) {
                setRegistrosStock(res);
                setRegistrosStockFilt(res);
            }
        }
        setLoad(false)
    }


    const handleChangetipoRegistro = (e) => {
        const ob = {...formData}
        ob["fechainicio"] = getCurrentDate()
        ob["fechafin"] = getCurrentDate()
        setFormData(ob);
        setCheck(false)
        switch (e.target.value) {
            case 'devolucionesYonke':
                setTipoRegistro(e.target.value)
                getData(e.target.value,true).then(()=>{
                    setCheck(true)
                })
                break;
            case 'devolucionesImport':
                setTipoRegistro(e.target.value)
                getData(e.target.value,true).then(()=>{
                    setCheck(true)
                })
                break;
            case 'modifStock':
                setTipoRegistro(e.target.value)
                getData(e.target.value,true).then(()=>{
                    setCheck(true)
                })
                break;

            default:
                break
        }
    }

    useEffect(() => {
        if (registrosStock === null) {
            getData('modifStock').then(()=>{
                setCheck(true)
            })
        }



        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])


    useEffect(() => {
        let aux = []
        if (checkidProducto) {
            aux.push('{"Header": "idProducto", "accessor": "idProducto"}')
        }
        if (checkProducto) {
            aux.push('{"Header": "Producto", "accessor": "producto"}')
        }
        if (checkiFisAnterior) {
            aux.push('{"Header": "I. Fisico Anterior", "accessor": "iFisicoAnterior"}')
        }
        if (checkiFisNuevo) {
            aux.push('{"Header": "I. Fisico Nuevo", "accessor": "iFisicoNuevo"}')
        }
        if (checkiFullAnterior) {
            aux.push('{"Header": "I. Full Anterior", "accessor": "iFullAnterior"}')
        }
        if (checkiFullNuevo) {
            aux.push('{"Header": "I. Full Nuevo", "accessor": "iFullNuevo"}')
        }
        if (checkStockAlAnt) {
            aux.push('{"Header": "Stock Alerta Anterior", "accessor": "stockAlertaAnterior"}')
        }
        if (checkStockAlNue) {
            aux.push('{"Header": "Stock Alerta Nuevo", "accessor": "stockAlertaNuevo"}')
        }
        if (checkTipoVenta) {
            aux.push('{"Header": "Tipo Venta", "accessor": "idVenta"}')
        }
        if (checkBuenEstado) {
            aux.push('{"Header": "Buen Estado", "accessor": "buenEstado"}')
        }
        if (checkFecha) {
            aux.push('{"Header": "Fecha", "accessor": "fecha"}')
        }
        if (checkHora) {
            aux.push('{"Header": "Hora", "accessor": "hora"}')
        }
        if (checkModifPor) {
            aux.push('{"Header": "Modificado Por", "accessor": "modificadoPor"}')
        }
        if (checkTipoModif) {
            aux.push('{"Header": "Tipo Modificacion", "accessor": "modifManual"}')
        }
        setStrtojson(JSON.parse(`[${aux.toString()}]`))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [checkidProducto, checkProducto, checkiFisAnterior, checkiFisNuevo, checkiFullAnterior, checkiFullNuevo, checkStockAlAnt, checkStockAlNue, checkTipoVenta, checkBuenEstado, checkFecha, checkHora, checkModifPor, checkTipoModif]);


    const handleCheck = (e) => {

        switch (e.target.value) {
            case 'idProducto':
                setCheckidProducto(e.target.checked)
                break;
            case 'Producto':
                setCheckProducto(e.target.checked)
                break;
            case 'I. Fisico Anterior':
                setCheckiFisAnterior(e.target.checked)
                break;
            case 'I. Fisico Nuevo':
                setCheckiFisNuevo(e.target.checked)
                break;
            case 'I. Full Anterior':
                setCheckiFullAnterior(e.target.checked)
                break;
            case 'I. Full Nuevo':
                setCheckiFullNuevo(e.target.checked)
                break;
            case 'Stock Alerta Anterior':
                setCheckStockAlAnt(e.target.checked)
                break;
            case 'Stock Alerta Nuevo':
                setCheckStockAlNue(e.target.checked)
                break;
            case 'Tipo Venta':
                setCheckTipoVenta(e.target.checked)
                break;
            case 'Buen Estado':
                setCheckBuenEstado(e.target.checked)
                break;
            case 'Fecha':
                setCheckFecha(e.target.checked)
                break;
            case 'Hora':
                setCheckHora(e.target.checked)
                break;
            case 'Modificado Por':
                setCheckModifPor(e.target.checked)
                break;
            case 'Tipo Modificacion':
                setCheckTipoModif(e.target.checked)
                break;

            default:
                break


        }

    }




    return (
        <DashboardLayout>
            <DashboardNavbar/>
            <MDBox mb={3}>
                <Grid>
                    <Grid item lg={12} xs={12}>
                        <Grid container padding={2} spacing={2} justifyContent="center" alignItems="center">
                            <Grid item xl={12} xs={12}>
                                <MDCard
                                    title={tipoRegistro === 'devolucionesYonke' ? 'Devoluciones Yonke' : tipoRegistro === 'devolucionesImport' ? 'Cancelaciones y/o Devoluciones' : tipoRegistro === 'modifStock' ? 'Modificaciones Stock' : 'Selecciona tipo de Venta'}>
                                    <Grid container padding={2} spacing={2} justifyContent="center" alignItems="center">
                                        <Grid item xl={12} xs={12}>
                                            <Grid container padding={2} spacing={2} justifyContent="center"
                                                  alignItems="center">
                                                <Grid item lg={3} xs={12}>
                                                    <MDButton variant="gradient" color="info"
                                                              startIcon={<Icon fontSize="small">search</Icon>}
                                                              value={'modifStock'}
                                                              fullWidth
                                                              onClick={handleChangetipoRegistro}
                                                    >
                                                        Modificaciones Stock
                                                    </MDButton>
                                                </Grid>
                                                <Grid item lg={3} xs={12}>
                                                    <MDButton variant="gradient" color="info"
                                                              startIcon={<Icon fontSize="small">search</Icon>}
                                                              value={'devolucionesImport'}
                                                              fullWidth
                                                              onClick={handleChangetipoRegistro}
                                                    >
                                                        Cancelaciones y/o Devoluciones
                                                    </MDButton>
                                                </Grid>
                                                <Grid item lg={3} xs={12}>
                                                    <MDButton variant="gradient" color="info"
                                                              startIcon={<Icon fontSize="small">search</Icon>}
                                                              value={'devolucionesYonke'}
                                                              fullWidth
                                                              onClick={handleChangetipoRegistro}
                                                    >
                                                        Devoluciones Yonke
                                                    </MDButton>
                                                </Grid>
                                                < Grid item lg={3} xs={12}>
                                                    <FormControlLabel
                                                        control={<Checkbox onClick={onCheck} checked={check}/>}
                                                        label="Ocultar mis Registros"
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </MDCard>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item lg={12} xs={12}>
                        <Grid container padding={2} spacing={2} justifyContent="center" alignItems="center">

                            <Grid item xl={12} xs={12}>
                                <Card>
                                    <Grid container padding={2} spacing={2} justifyContent="center">
                                        {!load ? (<></>) : (<Grid item xs="auto"><MDAvatar src={'images/loading.gif'}
                                                                                           shadow="sm"/></Grid>)}
                                        {tipoRegistro === 'devolucionesYonke' ?
                                            (
                                                <>
                                                    <Grid item lg={12} xs={12}>
                                                        <Grid container padding={2} spacing={2}
                                                              justifyContent="center"
                                                              alignItems="center">
                                                            <Grid item lg={12} xs={12}>
                                                                <Grid container spacing={2}
                                                                      justifyContent="center"
                                                                      alignItems="center">
                                                                    <Grid item lg={2} xs={12}>
                                                                        <MDInput type="date" label="De"
                                                                                 id="fechainicio"
                                                                                 fullWidth
                                                                                 value={formData.fechainicio}
                                                                                 onChange={handleChangeFecha}/>
                                                                    </Grid>
                                                                    <Grid item lg={2} xs={12}>
                                                                        <MDInput type="date"
                                                                                 label="Hasta"
                                                                                 id="fechafin" fullWidth
                                                                                 value={formData.fechafin}
                                                                                 onChange={handleChangeFecha}/>
                                                                    </Grid>
                                                                    <Grid item lg={2} xs={12}>
                                                                        <MDButton variant="gradient"
                                                                                  color="info"
                                                                                  startIcon={<Icon
                                                                                      fontSize="small">search</Icon>}
                                                                                  fullWidth
                                                                                  onClick={handleFiltrarRegistros}>
                                                                            Filtrar
                                                                        </MDButton>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item lg={12} xs={12}>
                                                        <Grid container padding={2} spacing={2}
                                                              justifyContent="center"
                                                              alignItems="center">
                                                            <Grid item lg={12} xs={12}>
                                                                <Grid container spacing={2}
                                                                      justifyContent="center"
                                                                      alignItems="center">
                                                                    <Grid item lg={12} xs={12}>
                                                                        <DataTable
                                                                            //--------------
                                                                            table={{
                                                                                columns: [
                                                                                    {Header: "ID Venta", accessor: "idVentas", width: "10%"},
                                                                                    {Header: "Linea", accessor: "linea", width: "20%"},
                                                                                    {Header: "Pieza", accessor: "pieza", width: "25%"},
                                                                                    {Header: "Fecha", accessor: "fecha_eliminacion", width: "15%"},
                                                                                    {Header: "Precio", accessor: "precio", width: "15%"},
                                                                                    {Header: "Devuelto Por", accessor: "eliminadoPor", width: "15%"}
                                                                                ],
                                                                                rows: registrosYonke ? registrosYonke : []
                                                                            }}
                                                                            canSearch={true}
                                                                            entriesPerPage={{ defaultValue: 50, entries: [5, 10, 20, 30, 40, 50] }}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>



                                                </>

                                            ) : (tipoRegistro === 'devolucionesImport' ?
                                                (
                                                    <>
                                                        <Grid item lg={12} xs={12}>
                                                            <Grid container padding={2} spacing={2}
                                                                  justifyContent="center"
                                                                  alignItems="center">
                                                                <Grid item lg={12} xs={12}>
                                                                    <Grid container spacing={2}
                                                                          justifyContent="center"
                                                                          alignItems="center">
                                                                        <Grid item lg={2} xs={12}>
                                                                            <MDInput type="date" label="De"
                                                                                     id="fechainicio"
                                                                                     fullWidth
                                                                                     value={formData.fechainicio}
                                                                                     onChange={handleChangeFecha}/>
                                                                        </Grid>
                                                                        <Grid item lg={2} xs={12}>
                                                                            <MDInput type="date"
                                                                                     label="Hasta"
                                                                                     id="fechafin" fullWidth
                                                                                     value={formData.fechafin}
                                                                                     onChange={handleChangeFecha}/>
                                                                        </Grid>
                                                                        <Grid item lg={2} xs={12}>
                                                                            <MDButton variant="gradient"
                                                                                      color="info"
                                                                                      startIcon={<Icon
                                                                                          fontSize="small">search</Icon>}
                                                                                      fullWidth
                                                                                      onClick={handleFiltrarRegistros}>
                                                                                Filtrar
                                                                            </MDButton>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                        <Grid item lg={12} xs={12}>
                                                            <Grid container padding={2} spacing={2}
                                                                  justifyContent="center"
                                                                  alignItems="center">
                                                                <Grid item lg={12} xs={12}>
                                                                    <Grid container spacing={2}
                                                                          justifyContent="center"
                                                                          alignItems="center">
                                                                        <Grid item lg={12} xs={12}>
                                                                            <DataTable
                                                                                //--------------
                                                                                table={{
                                                                                    columns: [
                                                                                        {Header: "idProducto", accessor: "idProducto", width: "10%"},
                                                                                        {Header: "Producto", accessor: "producto", width: "20%"},
                                                                                        {Header: "Cantidad", accessor: "cantidad", width: "10%"},
                                                                                        {Header: "Precio Unitario", accessor: "precio", width: "10%"},
                                                                                        {Header: "Precio Total", accessor: "precioTotal", width: "10%"},
                                                                                        {Header: "Buen Estado", accessor: "buenEstado", width: "5%"},
                                                                                        {Header: "Tipo Venta", accessor: "idVenta", width: "5%"},
                                                                                        {Header: "Fecha", accessor: "fecha_eliminacion", width: "10%"},
                                                                                        {Header: "ID Venta ML", accessor: "idVentaML", width: "10%"},
                                                                                        {Header: "Eliminado Por", accessor: "eliminadoPor", width: "10%"}
                                                                                    ],
                                                                                    rows: registrosImport ? registrosImport : []
                                                                                }}
                                                                                canSearch={true}
                                                                                entriesPerPage={{ defaultValue: 50, entries: [5, 10, 20, 30, 40, 50] }}
                                                                            />
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>



                                                    </>


                                                ) : (tipoRegistro === 'modifStock' ?
                                                    (
                                                        <>
                                                            <Grid item lg={12} xs={12}>
                                                                <Grid container padding={2} spacing={2}
                                                                      justifyContent="center"
                                                                      alignItems="center">
                                                                    <Grid item lg={12} xs={12}>
                                                                        <Grid container spacing={2}
                                                                              justifyContent="center"
                                                                              alignItems="center">
                                                                            <Grid item lg={2} xs={12}>
                                                                                <MDInput type="date" label="De"
                                                                                         id="fechainicio"
                                                                                         fullWidth
                                                                                         value={formData.fechainicio}
                                                                                         onChange={handleChangeFecha}/>
                                                                            </Grid>
                                                                            <Grid item lg={2} xs={12}>
                                                                                <MDInput type="date"
                                                                                         label="Hasta"
                                                                                         id="fechafin" fullWidth
                                                                                         value={formData.fechafin}
                                                                                         onChange={handleChangeFecha}/>
                                                                            </Grid>
                                                                            <Grid item lg={2} xs={12}>
                                                                                <MDButton variant="gradient"
                                                                                          color="info"
                                                                                          startIcon={<Icon
                                                                                              fontSize="small">search</Icon>}
                                                                                          fullWidth
                                                                                          onClick={handleFiltrarRegistros}>
                                                                                    Filtrar
                                                                                </MDButton>
                                                                            </Grid>
                                                                            < Grid item lg={2} xs={12}>

                                                                            </Grid>
                                                                            < Grid item lg={2} xs={12}>
                                                                                <FormControlLabel
                                                                                    control={<Checkbox onClick={onCheckManuales} checked={checkMan}/>}
                                                                                    label="Manuales"
                                                                                />
                                                                            </Grid>
                                                                            < Grid item lg={2} xs={12}>
                                                                                <FormControlLabel
                                                                                    control={<Checkbox onClick={onCheckAutomaticas} checked={checkAut}/>}
                                                                                    label="Automaticas"
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item lg={12} xs={12}>
                                                                <Grid container padding={2} spacing={2}
                                                                      justifyContent="center"
                                                                      alignItems="center">
                                                                    <Grid item lg={12} xs={12}>
                                                                        <Grid container spacing={2}
                                                                              justifyContent="center"
                                                                              alignItems="center">
                                                                            <Grid item lg={12} xs={12}>

                                                                                <DataTable
                                                                                    table={{
                                                                                        columns: strtojson,
                                                                                        rows: registrosStock ? registrosStock : []
                                                                                    }}
                                                                                    canSearch={false}
                                                                                    entriesPerPage={{ defaultValue: 20, entries: [5, 10, 20, 30, 40, 50] }}


                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid container padding={2} spacing={2} justifyContent="center" alignItems="center">
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkidProducto} onClick={handleCheck}/>}
                                                                        label="idProducto"
                                                                        value="idProducto"

                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkProducto} onClick={handleCheck}/>}
                                                                        label="Producto"
                                                                        value="Producto"

                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkiFisAnterior} onClick={handleCheck}/>}
                                                                        label="I. Fisico Anterior"
                                                                        value="I. Fisico Anterior"

                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkiFisNuevo} onClick={handleCheck}/>}
                                                                        label="I. Fisico Nuevo"
                                                                        value="I. Fisico Nuevo"

                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkiFullAnterior} onClick={handleCheck}/>}
                                                                        label="I. Full Anterior"
                                                                        value="I. Full Anterior"

                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkiFullNuevo} onClick={handleCheck}/>}
                                                                        label="I. Full Nuevo"
                                                                        value="I. Full Nuevo"
                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkStockAlAnt} onClick={handleCheck}/>}
                                                                        label="Stock Alerta Anterior"
                                                                        value="Stock Alerta Anterior"

                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkStockAlNue} onClick={handleCheck}/>}
                                                                        label="Stock Alerta Nuevo"
                                                                        value="Stock Alerta Nuevo"
                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkTipoVenta} onClick={handleCheck}/>}
                                                                        label="Tipo Venta"
                                                                        value="Tipo Venta"
                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkBuenEstado} onClick={handleCheck}/>}
                                                                        label="Buen Estado"
                                                                        value="Buen Estado"
                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkFecha} onClick={handleCheck}/>}
                                                                        label="Fecha"
                                                                        value="Fecha"
                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkHora} onClick={handleCheck}/>}
                                                                        label="Hora"
                                                                        value="Hora"
                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkModifPor} onClick={handleCheck}/>}
                                                                        label="Modificado Por"
                                                                        value="Modificado Por"
                                                                    />
                                                                </Grid>
                                                                < Grid item lg="auto" xs={'auto'}>
                                                                    <FormControlLabel
                                                                        control={<Checkbox checked={checkTipoModif} onClick={handleCheck}/>}
                                                                        label="Tipo Modificacion"
                                                                        value="Tipo Modificacion"
                                                                    />
                                                                </Grid>
                                                            </Grid>


                                                        </>

                                                    ) : ('')))}
                                    </Grid>
                                </Card>

                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    )
}

export default Registros;